export default {
    uah: '₴',
    validate: {
        Login: {
            email: {
                required: 'Email is required',
                email: 'Email is incorrect'
            },
            password: {
                required: 'Password is required',
                minLength: 'Min password length - 6'
            }
        },
        Register: {
            email: {
                required: 'Email is required',
                email: 'Email is incorrect'
            },
            password: {
                required: 'Password is required',
                minLength: 'Min password length - 6'
            },
            confirmPassword: {
                required: 'Confirm password is required',
                equal: 'Passwords does not match'
            },
            firstName: {
                required: 'Name is required'
            },
            lastName: {
                required: 'Surname is required'
            }
        },
        Payouts: {
            withdraw: {
                decimal: 'Amount is incorrect',
                availablePrice: 'Not enough funds in your account',
                multipleOf: 'Amount must be multiple of 100'
            }
        },
        Settings: {
            password: {
                required: 'Password is required',
                minLength: 'Min password length - 6'
            },
            newPassword: {
                required: 'New password is required',
                minLength: 'Min password length - 6'
            },
            confirmNewPassword: {
                required: 'Confirm new password is required',
                equal: 'Passwords does not match'
            },
            phoneNumber: {
                required: 'Phone number is required',
                length: 'Phone number is not correct'
            },
            passportNumber: {
                required: 'Passport number is required'
            },
            taxId: {
                required: 'Tax ID is required',
                length: 'Tax ID length - 10'
            },
            cardNumber: {
                required: 'Card number is required',
                length: 'Card number in not correct'
            },
            firstName: {
                required: 'First name is required'
            },
            lastName: {
                required: 'Last name is required'
            }
        },
        CreateAccount: {
            activeLeader: {
                required: 'Leader is required'
            },
            roleId: {
                required: 'Role is required'
            }
        },
        Payments: {
            orderId: {
                numeric: 'Order ID is incorrect'
            },
            phoneNumber: {
                numeric: 'Phone number is not correct'
            },
            taxiOrderId: {
                numeric: 'Taxi order ID is incorrect'
            },
            clientId: {
                numeric: 'Client ID is incorrect'
            }
        },
        Businesses: {
            businessId: {
                numeric: 'Business ID is incorrect'
            },
            refillSum: {
                required: 'Enter sum',
                numeric: 'Incorrect sum'
            },
            fee: {
                numeric: 'Fee is incorrect'
            },
            limits: {
                clientLimit: {
                    max: 'More than limit'
                }
            }
        },
        UnallocatedClients: {
            fee: {
                numeric: 'Fee is incorrect'
            }
        },
        Leaders: {
            leaderId: {
                numeric: 'Leader ID os incorrect'
            },
            refillSum: {
                required: 'Enter sum',
                numeric: 'Incorrect sum'
            },
            fee: {
                numeric: 'Fee is incorrect'
            },
            limits: {
                accountLimit: {
                    max: 'Max account limit - 10.000'
                },
                clientBase: {
                    max: 'Max client base - 1.000.000'
                }
            }
        },
        AdminEditor: {
            phoneNumber: {
                required: 'Phone number is required',
                length: 'Phone number is not correct'
            },
            taxId: {
                required: 'Tax ID is required',
                length: 'Tax ID length - 10'
            },
            cardNumber: {
                required: 'Card number is required',
                length: 'Card number in not correct'
            },
            firstName: {
                required: 'First name is required'
            },
            lastName: {
                required: 'Last name is required'
            },
            email: {
                required: 'Email is required',
                email: 'Email is incorrect'
            },
            passportNumber: {
                required: 'Passport number is required'
            }
        },
        RoleEditor: {
            name: {
                required: 'Role name is required'
            }
        },
        Cards: {
            clientId: {
                numeric: 'Client ID is incorrect'
            },
            paymentId: {
                numeric: 'Payment ID is incorrect'
            },
            phoneNumber: {
                length: 'Phone number is incorrect'
            }
        },
        News: {
            header: {
                required: 'Input a header'
            },
            publicationDate: {
                required: 'Choose a publication date'
            },
            publicationTime: {
                required: 'Choose a publication time'
            },
            text: {
                required: 'Enter a publication text',
                maxLength: 'Text should be less than 400 characters'
            },
            imageSize: {
                minValue: 'Image size is too long'
            }
        },
        BalanceHistory: {
            clientId: {
                numeric: 'Client ID is incorrect'
            },
            paymentId: {
                numeric: 'Payment ID is incorrect'
            },
            taxiOrderId: {
                numeric: 'Taxi order ID is incorrect'
            },
            phoneNumber: {
                required: 'Phone number is required',
                length: 'Phone number is incorrect'
            },
            amount: {
                required: 'Amount is required',
                numeric: 'Amount is incorrect'
            },
            comment: {
                length: 'Length is greater than 255 characters'
            }
        },
        Referral: {
            clientId: {
                numeric: 'Client ID is incorrect'
            }
        },
        Notification: {
            title: {
                required: 'Enter a title'
            },
            body: {
                maxLength: 'Too long'
            },
            phoneFilters: {
                maxLength: 'Too long'
            }
        },
        PromotionalLeader: {
            numberOfFunds: {
                required: 'Number of funds is required',
                decimal: 'Number of funds is not correct',
                isEnoughMoney: 'Not enough money'
            },
            amount: {
                required: 'Number of businesses is required'
            },
            accountId: {
                required: 'Leader is required'
            },
            date: {
                required: 'Date is required'
            }
        },
        PromotionalBusiness: {
            date: {
                required: 'Date is required'
            },
            accountId: {
                required: 'Business is required'
            },
            amount: {
                required: 'Number of business is required'
            }
        },
        PurchasePromotional: {
            money: {
                required: 'Enter amount',
                decimal: 'Amount is not correct',
                isEnoughMoney: 'Not enough money'
            }
        },
        Groups: {
            name: {
                required: 'Name is required'
            },
            phones: {
                required: 'Phones is required'
            },
            brand: {
                required: 'Choose a brand'
            },
            subGroups: {
                numeric: 'Incorrect value',
                max: 'Maximum exceeded',
                min: 'Below minimum'
            },
            count: {
                required: 'Field is required',
                numeric: 'Incorrect value',
                max: 'Maximum exceeded',
                min: 'Incorrect value'
            },
            fromDate: {
                required: 'From date is required',
                max: 'Incorrect value'
            },
            toDate: {
                required: 'To date is required',
                max: 'Maximum exceeded'
            }
        },
        CashbackEditor: {
            name: {
                required: 'Name is required'
            },
            groupId: {
                required: 'Group is required'
            },
            fromDate: {
                required: 'From date is required'
            },
            toDate: {
                required: 'To date is required'
            }
        },
        ExtendedReports: {
            Editor: {
                name: {
                    required: 'Report name is required'
                },
                sqlQuery: {
                    required: 'SQL-query is required'
                }
            },
            Categories: {
                name: {
                    required: 'Category name is required'
                }
            }
        },
        other: {
            numeric: 'Incorrect value'
        }
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    menu: {
        addClientArticle: 'Create article',
        articleList: 'Article list',
        login: 'Login',
        clientNews: 'Client news',
        clientArticleEditor: 'Client article editor',
        register: 'Register',
        dashboard: 'Information panel',
        admin: 'Admin',
        admins: 'Admins',
        customers: 'Customers',
        customerEditor: 'Editing customer',
        adminEditor: 'Admin editing',
        rolesManaging: 'Roles management',
        roles: 'List of roles',
        createRole: 'Create new role',
        permissions: 'List of permissions',
        user: 'User',
        payments: 'Payments',
        paymentLog: 'Payment Logs',
        referral: 'Referrals',
        customersBase: 'Customers base',
        business: 'Businesses',
        yourBusinesses: 'Your businesses',
        card: 'Cards',
        news: 'News',
        balanceHistory: 'Balance History',
        notification: 'Push-notifications',
        createAccount: 'Create Account',
        leaders: 'Leaders',
        accountBalanceHistory: 'Finances',
        clientRefillHistory: 'Client balance refill history',
        leaderReferralCodes: 'Сodes for inviting clients',
        businessReferralCodes: 'Сodes for inviting businesses',
        payouts: 'Payouts',
        payoutsLogs: 'Request History',
        reports: 'Reports',
        leaderReport: 'Reports',
        businessReport: 'Reports',
        systemNotifications: 'Notifications',
        systemLogs: 'Activity',
        systemLogsSettings: 'Activity settings',
        settings: 'Settings',
        leaderGroup: 'By leaders',
        businessGroup: 'By businesses',
        dayGroup: 'Withdraw funds',
        reportLeaderGroup: 'Leader Report',
        reportBusinessGroup: 'Business Report',
        reportDayGroup: 'Withdrawal Report',
        extendedReports: 'Extended reports',
        extendedReportsList: 'Extended reports list',
        extendedReportsCategories: 'Extended reports categories',
        promotionalAccount: 'Promotional account',
        bonusSystems: 'Bonus systems',
        groups: 'Client groups',
        cashbackSystems: 'Cashback & bonuses',
        cashbackEditor: 'Edit bonus system',
        cashbackCreator: 'Create bonus system',
        unallocatedClients: 'Unallocated Clients',
        moderation: 'Moderation',
        undefined: ''
    },
    pages: {
        ClientNewsEditor: {
            articleData: 'Article data'
        },
        ClientNews: {
            sendTo: {
                all: 'All clients',
                allDelivery: 'Delivery clients',
                allTaxi: 'Taxi clients',
                selected: 'Chosen clients'
            },
            delete: 'Delete',
            cancel: 'Cancel',
            table: {
                text: 'Text',
                sendTo: 'Send to',
                header: 'Title',
                status: 'Status',
                createdAt: 'Created at',
                actions: 'Actions',
                id: 'ID'
            },
            status: {
                shown: 'Shown',
                hide: 'Hidden'
            },
            deleteTitle: 'Are you sure to delete this article?',
            cannotBeUndone: 'This action cannot be undone'
        },
        AddClientArticle: {
            sendTo: {
                all: 'All',
                allTaxi: 'All (taxi)',
                allDelivery: 'All (delivery)',
                selected: 'Manual'
            }
        },
        Login: {
            title: 'Login in system',
            submit: 'Login',
            form: {
                email: 'Email',
                password: 'Password'
            },
            forgotPassword: 'Forgot password?',
            rememberMe: 'Remember me',
            socialTitle: 'Or login with',
            emailText: 'We sent instructions for password recovery to <strong>:email</strong> (check your «Inbox» and «Spam» folders).',
            forgotPasswordTitle: 'Instructions sent',
            emailSubject: 'Forgot your password? Restore it!',
            forgotText: 'Hello! You have sent a password reset request from your email address. To set a new password, follow the link'
        },
        Register: {
            title: 'Register in system',
            submit: 'Register',
            form: {
                email: 'Email',
                firstName: 'Name',
                lastName: 'Surname',
                password: 'Password',
                confirmPassword: 'Confirm password',
                role: 'Role',
                includeTelephony: 'Include telephony orders'
            }
        },
        ReferralCodes: {
            editText: 'Press Enter to save',
            table: {
                name: 'Name',
                code: 'Code',
                actions: ''
            }
        },
        Dashboard: {
            overviewBalance: 'Your balance',
            overviewPercent: 'Percent',
            overviewFee: 'Online fee',
            overviewTelephonyFee: 'Offline fee',
            overviewClients: 'Number of Clients',
            overviewBusinesses: 'Number of Businesses',
            clientBase: 'Client base',
            clientLimit: 'Client limit',
            accountLimit: 'Account limit',
            autoPromoBalance: 'Auto promo balance',
            promoBalance: 'Promo balance',
            referralTitle: 'History of attracted partners',
            balanceTitle: 'Your earnings history',
            noDataReferrals: 'You haven’t attracted anyone yet',
            noDataBalance: 'You haven’t earned anything yet',
            noOrders: 'You haven`t orders yes',
            ordersAnalytics: 'Orders analytics',
            ordersTitle: 'Your order history',
            ordersIncomeTitle: 'Orders history income',
            table: {
                balance: 'Balance',
                clients: 'Clients',
                online: 'Online orders',
                offline: 'Offline orders',
                deliveryOrders: 'Delivery orders'
            },
            dateMenu: {
                month: 'Month',
                week: 'Week',
                day: 'Day'
            }
        },
        UnallocatedClients: {
            cards: {
                workedServerCount: 'Count of servers',
                all: 'Count of clients',
                unallocated: 'Unallocated clients',
                allocated: 'Allocated clients'
            },
            table: {
                id: 'ID',
                name: 'Name',
                enabled: 'Enabled',
                apiUrl: 'API url',
                apiKey: 'API key',
                balance: 'Balance',
                fee: 'Fee',
                createdAt: 'Created at',
                city: 'City',
                actions: ''
            },
            enabled: {
                true: 'Yes',
                false: 'No'
            },
            editFeeText: 'Press Enter to save',
            reset: {
                title: 'Confirm action',
                text: 'Are you sure you want to reset the balance of this server?',
                actions: {
                    agree: 'Agree',
                    disagree: 'Disagree'
                }
            }
        },
        RefRegister: {
            title: 'Welcome to Sprut',
            invalidCode: 'Invalid referral code',
            confirmation: 'Please type the verification code sent to',
            registered: 'Congratulations! You became a client of SPRUT',
            buttons: {
                appStore: 'Download from <br> <b>App Store</b>',
                googlePlay: 'Download from  <br> <b>Google Play</b>'
            }
        },
        Payments: {
            autocomplete: {
                type: 'Select payment type',
                status: 'Select payment status',
                cardBinding: 'Adding card (1₴)',
                orderPayment: 'Trip payment',
                rechargeBalance: 'Balance replenishment',
                new: 'New',
                success: 'Success',
                deliveryPayment: 'Delivery payment',
                error: 'Error',
                sandbox: 'Sandbox'
            },
            table: {
                clientId: 'Client ID',
                phoneNumber: 'Phone number',
                taxiOrderId: 'Order ID',
                orderId: 'Transaction ID',
                amount: 'Amount',
                status: 'Status',
                type: 'Type',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                actions: ''
            },
            link: 'To payment log',
            clientId: 'Client ID',
            phoneNumber: 'Phone number',
            taxiOrderId: 'Order ID',
            orderId: 'Transaction ID'
        },
        PaymentLogs: {
            table: {
                request: 'Request',
                response: 'Response',
                type: 'Type',
                createdAt: 'Created at',
                updatedAt: 'Updated at'
            }
        },
        Referrals: {
            tableTitle: 'Your clients',
            autocomplete: {
                noData: 'Data is not available'
            },
            table: {
                clientId: 'Client ID',
                createdAt: 'Registered at',
                paymentType: 'Default payment type',
                balance: 'Balance',
                card: 'Card',
                cash: 'Cash',
                referralCode: 'Referral code',
                referralCodeName: 'Referral code name',
                businessEmail: 'Invited a client',
                leaderEmail: 'Leader email'
            },
            clientId: 'Client ID',
            businessShareText: 'Call a taxi in 3 seconds? Everything is possible with Sprut! Download the mobile application via link: ',
            leaderShareText: 'Congratulations! Start your taxi business now! Register at: '
        },
        Admins: {
            email: 'Email',
            role: 'Role name',
            phone: 'Phone number',
            table: {
                id: 'Admin ID',
                email: 'Email',
                createdAt: 'Created at',
                firstName: 'Name',
                lastName: 'Surname',
                appVersion: 'App version',
                cardNumber: 'Card number',
                taxId: 'Tax id',
                phoneNumber: 'Phone number',
                role: 'User role',
                actions: 'Actions'
            }
        },
        AdminEditor: {
            adminInfo: 'Information about admin',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            customerInfo: 'Customer details',
            phoneNumber: 'Phone number',
            cardNumber: 'Card number',
            taxId: 'Tax ID',
            passportNumber: 'Passport number',
            roleInfo: 'Information about role',
            role: 'Role'
        },
        Roles: {
            name: 'Role name',
            table: {
                name: 'Role name',
                adminsCount: 'User count',
                state: 'State',
                actions: 'Actions',
                active: 'Active',
                disabled: 'Not active'
            },
            permissionsSettings: {
                name: 'Permission name',
                activation: 'Activation'
            },
            permissionsList: {
                'watch-payments': 'Watch payments list',
                'send-push-notifications': 'Push-notifications sending',
                'watch-balance-history': 'Watch balance history',
                'refill-client-balance': 'Refill client balance',
                'watch-cards': 'Watch users cards',
                'watch-leaders': 'Watch leaders list',
                'watch-business': 'Watch business list',
                'create-account': 'Create accounts',
                'watch-referrals': 'Access to referrals list',
                'create-news': 'Work with publications',
                'watch-account-balance-history': 'Access to account balance history',
                'edit-withdraws': 'Watch withdraws history and work with them',
                'watch-reports': 'Watch reports',
                'edit-admins': 'Watch admins list and work with it',
                'edit-roles': 'Access to the list of roles and work with them',
                'change-admin-permissions': 'Access to all permissions list',
                'watch-extended-reports': 'Watch extended reports',
                'edit-extended-reports': 'Edit extended reports',
                'watch-client-groups': 'Watch client groups',
                'watch-cashback-system': 'Watch cashback system',
                'watch-unallocated-clients': 'Watch unallocated clients',
                'watch-client-refill-history': 'Watch client refill history',
                'watch-system-logs': 'Watch activity',
                'lock-account': 'Lock accounts'
            }
        },
        RoleEditor: {
            name: 'Role name',
            edit: 'Edit role',
            create: 'New role',
            available: 'Available',
            chosen: 'Chosen',
            established: 'Established',
            permissionsList: 'List of role permissions',
            reportCategoriesList: 'Reports categories',
            active: 'Active',
            disabled: 'Not active',
            emptyList: 'Permissions list is empty'
        },
        Businesses: {
            tableTitleConfirmed: 'List of businesses - {0}',
            tableTitleUnconfirmed: 'List of unconfirmed businesses - {0}',
            adminTitle: 'List of businesses',
            adminUnconfirmedTitle: 'List of unconfirmed businesses',
            businessId: 'Enter business ID',
            query: 'Query',
            table: {
                businessId: 'Business ID',
                email: 'Email',
                firstName: 'Name',
                lastName: 'Surname',
                phoneNumber: 'Phone number',
                createdAt: 'Created at',
                referrerEmail: 'Leader email',
                balance: 'Balance',
                refillBalance: 'Fill balance',
                refillPromoBalance: 'Fill promo balance',
                fee: 'Online fee',
                telephonyFee: 'Offline fee',
                leaderFee: 'Leader online %',
                leaderTelephonyFee: 'Leader offline %',
                clients: 'Referrals',
                clientLimit: 'Client limit',
                limitedTo: 'Limited to',
                processedAfterRestrictions: 'Processed after restrictions',
                unlimitedRights: 'Unlimited rights',
                purchased: 'Account purchased',
                autoPromoBalance: 'Auto promo balance',
                actions: 'Actions',
                lock: 'Lock account',
                unlock: 'Unlock account',
                settings: 'Limits settings',
                amountToPay: 'Amount to pay',
                amountPaid: 'Amount paid'
            },
            limits: {
                title: 'Change limits',
                available: 'Total available: {0}',
                used: 'Used'
            },
            refillSum: 'Enter refill sum',
            lockDialog: {
                title: 'Lock business',
                message: 'This business account will be locked and he can\'t access the system'
            }
        },
        Cards: {
            table: {
                id: 'ID',
                clientId: 'Client ID',
                phoneNumber: 'Client phone number',
                paymentId: 'Payment ID',
                cardMask: 'Card mask',
                cardToken: 'Card token',
                default: 'Default',
                errorCount: 'Error Count',
                createdAt: 'Created At',
                updatedAt: 'Updated At'
            },
            clientId: 'Client ID',
            paymentId: 'Payment ID',
            phoneNumber: 'Client phone number',
            true: 'Yes',
            false: 'No'
        },
        News: {
            selects: {
                all: 'All',
                leader: 'Leaders',
                business: 'Businesses'
            },
            count: 'Count of news',
            header: 'Information for partners',
            showTo: 'Show to',
            showText: 'Publication',
            latePublication: 'Late publication',
            publicationDate: 'Publication date',
            publicationTime: 'Publication time',
            text: 'News text',
            image: 'Choose an image',
            share: 'Choose a referral code for sharing',
            noCode: 'You haven\'t any referral code. Create it before sharing',
            edit: 'Edit publication',
            create: 'New publication',
            shareImageBlock: {
                code: {
                    size: 'Size(px)',
                    position: 'Position',
                    positions: {
                        'top-left': 'Top left',
                        'top-right': 'Top right',
                        'bottom-left': 'Bottom left',
                        'bottom-right': 'Bottom right'
                    }
                },
                addQRCode: 'Add QR code'
            }
        },
        balanceHistories: {
            table: {
                id: 'ID',
                clientId: 'Client ID',
                phoneNumber: 'Client phone number',
                taxiOrderId: 'Order ID',
                paymentId: 'Payment ID',
                change: 'Change',
                balance: 'Balance',
                cashbackSystemId: 'Bonus System ID',
                paymentType: 'Payment type',
                comment: 'Comment',
                orderType: 'Order type',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                refilledBy: 'Refilled by',
                system: 'System',
                success: 'Success'
            },
            refillDialog: {
                title: 'Refill client balance',
                phoneNumber: 'Phone number',
                sum: 'Replenishment amount',
                comment: 'Comment'
            },
            clientId: 'Client ID',
            taxiOrderId: 'Order ID',
            paymentId: 'Payment ID',
            paymentType: 'Payment type',
            paymentTypes: {
                refill: 'Balance refill',
                trip: 'Trip',
                taxi: 'Taxi',
                delivery: 'Delivery',
                cashback: 'Cashback'
            },
            phoneNumber: 'Client phone number'
        },
        Notification: {
            count: 'Number of notifications',
            clients: 'Ready to send',
            filters: {
                selectAll: 'Select all clients',
                phones: 'Phone numbers',
                success: 'Success',
                duplicate: 'Duplicate',
                notFound: 'Not found',
                withoutToken: 'Without token',
                validationError: 'Validation error'
            },
            message: {
                title: 'Title *',
                body: 'Text',
                image: 'Image link'
            },
            result: {
                title: 'Results',
                androidSuccess: 'Android success',
                androidFailure: 'Android failure',
                iosSuccess: 'iOS success',
                iosFailure: 'iOS failure'
            },
            error: {
                emptyToken: 'Device token not sent',
                requiredData: 'The request body field was not sent',
                CouldNotParsed: 'The request body could not be read',
                InvalidRegistration: 'Invalid registration',
                NotRegistered: 'Not registered',
                InvalidPackageName: 'Invalid package name',
                MismatchSenderId: 'Mismatch sender id',
                InvalidParameters: 'Invalid parameters',
                MessageTooBig: 'Message too big',
                InvalidDataKey: 'Invalid data key',
                Unavailable: 'Unavailable',
                DeviceMessageRateExceeded: 'Device message rate exceeded',
                BadCollapseId: 'Bad collapse id',
                BadDeviceToken: 'Bad device token',
                BadExpirationDate: 'Bad expiration date',
                BadMessageId: 'Bad message id',
                BadPriority: 'Bad priority',
                BadTopic: 'Bad topic',
                DeviceTokenNotForTopic: 'Device token not for topic',
                DuplicateHeaders: 'Duplicate headers',
                IdleTimeout: 'Idle timeout',
                MissingDeviceToken: 'Missing device token',
                MissingTopic: 'Missing topic',
                PayloadEmpty: 'Payload empty',
                TopicDisallowed: 'Topic disallowed',
                BadCertificate: 'Bad certificate',
                BadCertificateEnvironment: 'Bad certificate environment',
                ExpiredProviderToken: 'Expired provider token',
                Forbidden: 'Forbidden',
                InvalidProviderToken: 'Invalid provider token',
                MissingProviderToken: 'Missing provider token',
                BadPath: 'Bad path',
                MethodNotAllowed: 'Method not allowed',
                Unregistered: 'Unregistered',
                PayloadTooLarge: 'Payload too large',
                TooManyProviderTokenUpdates: 'Too many provider token updates',
                TooManyRequests: 'Too many requests',
                InternalServerError: 'Internal server error',
                ServiceUnavailable: 'Service unavailable',
                Shutdown: 'Shutdown'
            }
        },
        CreateAccounts: {
            selects: {
                admin: 'Admin',
                leader: 'Leader',
                business: 'Business'
            }
        },
        Leaders: {
            or: 'or',
            id: 'Enter leader ID',
            query: 'Query',
            table: {
                id: 'Leader ID',
                email: 'Email',
                createdAt: 'Created at',
                firstName: 'Name',
                lastName: 'Surname',
                phoneNumber: 'Phone number',
                balance: 'Balance',
                refillBalance: 'Fill balance',
                refillPromoBalance: 'Fill promo balance',
                fee: 'Online fee',
                telephonyFee: 'Offline fee',
                brandCode: 'Brand code',
                clientBase: 'Client base',
                accountLimit: 'Account limit',
                limitedTo: 'Limited to',
                processedAfterRestrictions: 'Processed after restrictions',
                unlimitedRights: 'Unlimited rights',
                purchased: 'Account purchased',
                clients: 'Referrals',
                businesses: 'Businesses',
                distributedClients: 'Distributed clients',
                promoBalance: 'MPB',
                autoPromoBalance: 'APB',
                actions: 'Actions',
                enableTelephony: 'Enable offline orders',
                disableTelephony: 'Disable offline orders',
                lock: 'Lock account',
                unlock: 'Unlock account',
                settings: 'Limits settings',
                amountToPay: 'Amount to pay',
                amountPaid: 'Amount paid'
            },
            limits: {
                title: 'Change limits'
            },
            refillSum: 'Enter refill sum',
            lockDialog: {
                title: 'Lock leader',
                message: 'This leader account will be locked and he can\'t access the system'
            }
        },
        Settings: {
            form: {
                password: 'Password',
                newPassword: 'New password',
                confirmNewPassword: 'Confirm new password'
            },
            tabs: {
                details: 'Personal details',
                settings: 'Sign in settings'
            },
            labels: {
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Email',
                phoneNumber: 'Phone number',
                cardNumber: 'Card number',
                taxId: 'Tax ID',
                passportNumber: 'Passport number'
            },
            personalInfo: 'Personal information',
            additionalInfo: 'Additional information',
            connectAccount: 'Connect account',
            changePass: 'Change password',
            fbAccount: 'Facebook account',
            googleAccount: 'Google account',
            confirmation: {
                title: 'Save your personal data',
                description: 'If you confirm saving, your account will be temporarily blocked, and the data will be transferred to the administration for consideration.'
            },
            agreedWith: 'Agreed with',
            termsOfUsage: 'terms of usage'
        },
        BusinessRegister: {
            title: 'Confirm your email!',
            description: 'Your account has been successfully registered. To complete the process please check your email for a validation request.',
            emailSubject: 'You have successfully registered! It remains only to confirm the mail!',
            registerText: 'We are glad to see you in our SPRUT team. The last step is left! Follow the link to confirm your account registration'
        },
        AccountBalanceHistory: {
            currentAccountBalance: 'Your current balance (₴)',
            table: {
                partner: 'Partner',
                clientId: 'Client ID',
                taxiOrderId: 'Taxi order ID',
                change: 'Change',
                balance: 'Balance',
                cashbackSystemId: 'Cashback System ID',
                bonusBalance: 'Show bonus balance',
                phoneNumber: 'Phone number',
                type: 'Change type',
                email: 'Email',
                createdAt: 'Created at',
                statuses: {
                    trip: 'Trip',
                    refill: 'Refill',
                    delivery: 'Delivery'
                }
            }
        },
        clientRefillHistory: {
            table: {
                date: 'Date',
                change: 'Amount',
                balance: 'Balance',
                phoneNumber: 'Phone number',
                refilledBy: 'Refilled by',
                comment: 'Comment'
            }
        },
        Payouts: {
            table: {
                sum: 'Amount',
                accountId: 'Account ID',
                type: 'Type',
                email: 'Email',
                firstName: 'First name',
                lastName: 'Last name',
                phoneNumber: 'Phone number',
                balance: 'Balance',
                status: 'Status',
                cardNumber: 'Card number',
                comment: 'Comment',
                updatedAt: 'Updated at',
                createdAt: 'Requested at'
            },
            statuses: {
                new: 'New',
                processing: 'In process',
                success: 'Completed',
                cancelled: 'Cancelled'
            },
            filters: {
                status: 'Select status',
                query: 'Query'
            },
            payoutDescription: 'You can leave a request for withdrawal of earned funds. Average waiting time is 3 banking days. The request can be rejected in case of fraudulent actions on the account.',
            payoutDialogTitle: 'Are you sure you want to withdraw ',
            onBalance: 'On your balance',
            withdraw: 'Withdrawal of funds',
            withdrawAll: 'Widthdraw all the money',
            sum: 'Sum in UAH',
            hrn: 'UAH'
        },
        Reports: {
            sum: 'Sum',
            table: {
                date: 'Date',
                invitedClients: 'Invited clients',
                totalTrips: 'Total trips',
                earnedMoney: 'Earned money'
            },
            leader: {
                table: {
                    business: 'Business',
                    invitedClients: 'Invited clients',
                    totalTrips: 'Total trips',
                    earnedMoney: 'Earned money by leader',
                    earnedReferralsMoney: 'Earned money by business'
                }
            },
            admin: {
                table: {
                    business: 'Business',
                    date: 'Date',
                    totalBalance: 'Total Balance',
                    requested: 'Requested',
                    success: 'Withdrawn',
                    leader: 'Leader',
                    invitedBusinesses: 'Invited businesses',
                    invitedClients: 'Invited clients',
                    totalTrips: 'Total trips',
                    earnedLeaderMoney: 'Earned money by leader',
                    earnedBusinessMoney: 'Earned money by business',
                    earnedBusinessesMoney: 'Earned money by businesses'
                }
            }
        },
        ExtendedReports: {
            List: {
                table: {
                    '#': '#',
                    name: 'Name',
                    category: 'Category',
                    sqlQuery: 'SQL-query',
                    created: 'Created',
                    updated: 'Updated',
                    actions: 'Actions',
                    forLeader: 'For leader'
                },
                filters: {
                    sqlQuery: 'SQL-query'
                }
            },
            Editor: {
                create: 'New report',
                edit: 'Report editing',
                remove: 'Are you sure want to remove this report ?',
                name: 'Name',
                category: 'Category',
                sqlQuery: 'SQL-query',
                meta: 'SQL-metadata',
                useDate: 'Filter by date',
                useTime: 'Filter by time',
                useQuery: 'Text request',
                forLeader: 'For leader'
            },
            Reports: {
                category: 'Category',
                report: 'Report',
                filtration: 'Filtration',
                another: 'Another',
                filters: {
                    startDate: 'Start date',
                    endDate: 'End date',
                    startTime: 'Start time',
                    endTime: 'End time',
                    query: 'Text query'
                }
            },
            Categories: {
                name: 'Name',
                list: 'Reports categories list',
                action: 'Actions',
                remove: 'Are you really want to remove this category ?',
                edit: 'Category editing',
                create: 'New category'
            }
        },
        PayoutLog: {
            table: {
                id: 'ID',
                status: 'Status',
                updatedAt: 'Updated at',
                createdAt: 'Created at'
            }
        },
        SystemNotifications: {
            title: {
                newBusiness: 'New business',
                emailConfirmed: 'Email confirmation',
                newClient: 'New client',
                refilledPromoBalance: 'Refill promotional account',
                withdrawRequest: 'Withdraw request',
                resetFee: 'Reset percent'
            },
            autocomplete: {
                type: 'Choose a type',
                status: 'Choose a status',
                read: 'Read',
                unread: 'Not read',
                newBusiness: 'New business',
                emailConfirmed: 'Business confirmed his email',
                newClient: 'New client',
                refilledPromoBalance: 'Refill promotional account',
                withdrawRequest: 'Withdraw request'
            },
            refilledPromoBalance: 'Refill promotional account on {currency} hrn',
            newBusiness: 'Businessman {content} has become your partner!',
            emailConfirmed: 'Businessman {content} confirmed his e-mail!',
            newClient: 'Congratulations! The client {content} registered and became your partner!',
            withdrawRequest: '{content} requested a withdrawal!',
            noData: 'You don\'t have any notifications',
            resetFee: '18.06. 2021г. bonus accrual of dividends ends. For further cooperation, you need to contact the administration.'
        },
        ConfirmAccount: {
            confirmedTitle: 'Account successfully verified',
            unconfirmedTitle: 'The link is no longer valid',
            subject: 'Account confirmation',
            text: 'To confirm your account, follow the link'
        },
        SystemLogs: {
            actionType: 'Action type',
            email: 'User',
            models: {
                ClientGroup: {
                    name: 'Name',
                    type: 'Type',
                    countOfOrders: 'Count of orders',
                    values: 'Count of orders',
                    subGroups: 'Subgroups amount',
                    fromDate: 'From date',
                    toDate: 'To date',
                    includeUnallocated: 'Include unallocated',
                    onlyUnallocated: 'Only unallocated',
                    accountId: 'Clients of user with id',
                    brandId: 'Brand ID',
                    isDelivery: 'Delivery group',
                    brand: 'Brand'
                },
                CashbackSystem: {
                    name: 'Name',
                    clientGroup: 'Clients group',
                    fromDate: 'From date',
                    toDate: 'To date',
                    includeTelephony: 'Include offline orders',
                    bonusReward: 'Reward',
                    textOnCreate: 'Text on create',
                    textOnReward: 'Text on reward',
                    Step: {
                        name: 'Name of the cashback system',
                        percent: 'Cashback percentage',
                        text: 'Text when reaching',
                        order: 'Number of orders'
                    }
                },
                RASystem: {
                    name: 'Name of the bonus system',
                    clientGroup: 'Clients group',
                    fromDate: 'Start date',
                    toDate: 'End date',
                    bonusReward: 'Reward',
                    textOnCreate: 'Text on create',
                    textOnReward: 'Text on reward',
                    Step: {
                        name: 'Name of the bonus system',
                        bonusReward: 'Reward',
                        text: 'Text when reaching',
                        bonusCondition: 'Condition of reaching'
                    }
                },
                LTSystem: {
                    name: 'Name of the bonus system',
                    clientGroup: 'Clients group',
                    fromDate: 'Start date',
                    toDate: 'End date',
                    bonusReward: 'Reward',
                    textOnCreate: 'Text on create',
                    textOnReward: 'Text on reward',
                    Step: {
                        name: 'Name of the bonus system',
                        bonusReward: 'Reward',
                        text: 'Text when reaching',
                        bonusCondition: 'Condition of reaching'
                    }
                }
            },
            table: {
                date: 'Date',
                user: 'User',
                actionType: 'Action type',
                action: 'Action'
            },
            types: {
                'login': 'Login',
                'push-notification-send': 'Push notifications',
                'refill-account-balance': 'Refill account balance',
                'create-code': 'Create Referral Code',
                'create-account': 'Create Account',
                'create-news': 'Post creation',
                'remove-news': 'Post removal',
                'change-action-type-status': 'Change action type status',
                'remove-code': 'Delete referral code',
                'change-personal-data': 'Change of personal data',
                'connect-google-account': 'Connecting a google account',
                'connect-facebook-account': 'Connecting facebook account',
                'change-servers-fee': 'Change servers fee',
                'set-to-zero-server-balance': 'Set to zero server balance',
                'change-permission': 'List of all permissions changes',
                'change-admin-data': 'Change admin data',
                'change-role': 'Role editing',
                'create-role': 'Role creation',
                'remove-role': 'Role removal',
                'change-fee': 'Change fee',
                'create-client-group': 'Create client group',
                'edit-client-group': 'Edit client group',
                'remove-client-group': 'Remove client group',
                'create-cashback-system': 'Create cashback system',
                'change-cashback-system-activity': 'Cashback system activation',
                'edit-cashback-system': 'Cashback system changes',
                'complete-cashback-system': 'Cashback system complete',
                'create-cashback-step': 'Create cashback step',
                'edit-cashback-step': 'Edit cashback step',
                'remove-cashback-step': 'Remove cashback step',

                'create-ra-system': 'Create "reach amount" bonus system',
                'edit-ra-system': 'Edit "reach amount" bonus system',
                'change-ra-system-activity': 'Activate "reach amount" bonus system',
                'complete-ra-system': 'Complete "reach amount" bonus system',

                'create-lt-system': 'Create "limited time" bonus system',
                'edit-lt-system': 'Edit "limited time" bonus system',
                'change-lt-system-activity': 'Activate "limited time" bonus system',
                'complete-lt-system': 'Complete "limited time" bonus system',

                'create-ra-step': 'Create "reach amount" step',
                'edit-ra-step': 'Edit "reach amount" step',
                'remove-ra-step': 'Remove "reach amount" step',

                'create-lt-step': 'Create "limited time" step',
                'edit-lt-step': 'Edit "limited time" step',
                'remove-lt-step': 'Remove "limited time" step',

                'funds-purchase': 'Purchase of promotional funds',
                'funds-charge': 'Promotional balance charge',
                'lock-account': 'Account lock',
                'change-account-status': 'Change account status',
                'change-account-price': 'Change account price'
            },
            messages: {
                'login': 'Session was created with remember parameter {0}',
                'refill-account-balance': 'Balance of user {0} was refilled by {1} UAH',
                'create-code': 'User {0} created a referral code {1} with name "{2}"',
                'remove-code': 'User {0} removed a referral code {1} with name {2}',
                'create-account': 'New account {0} was created with role "{1}"',
                'lock-account': 'Account {0} was {1}',
                'change-action-type-status': 'Action type "{0}" was {1}',
                'change-permission': 'Permission type "{0}" was {1}',
                'create-news': 'User {0} created a post with header "{1}"',
                'remove-news': 'User {0} removed a post with header "{1}"',
                'connect-google-account': 'User {0} connected a google-account',
                'connect-facebook-account': 'User {0} connected a facebook-account',
                'push-notification-send': 'User {0} sent push-notifications for {1} clients: {2} success, {3} failure',
                'change-servers-fee': 'Change fee for server {0} - from {1} to {2}',
                'set-to-zero-server-balance': 'Set balance to zero for server - {0}',
                'create-role': 'Admin {0} created a role "{1}" with permissions: {2}.',
                'remove-role': 'Role "{0}" was removed.',
                'change-fee': 'Admin {0} changed fee for account {1} from {2}% to {3}%',
                'create-client-group': 'Client group "{0}" was created with parameters:\n{1}',
                'remove-client-group': 'Client group "{0}" was removed',
                'create-cashback-system': 'Cashback system was created with parameters:\n{0}',
                'change-cashback-system-activity': 'Cashback system "{0}" -> {1}',
                'complete-cashback-system': 'Cashback system "{0}" was completed',

                'create-ra-system': 'Created "reach amount" bonus system with parameters:\n{0}',
                'change-ra-system-activity': '"Reach amount" bonus system "{0}" -> {1}',
                'complete-ra-system': '"Reach amount" bonus system "{0}" was completed',

                'create-lt-system': 'Created "limited time" bonus system with parameters:\n{0}',
                'change-lt-system-activity': '"Limited time" bonus system "{0}" -> {1}',
                'complete-lt-system': '"Limited time" bonus system "{0}" was completed',

                'change-personal-data': {
                    user: 'User {0}',
                    add: 'filled a field "{0}" with value "{1}" in his account',
                    change: 'changed a "{0}" field in his account from "{1}" to "{2}"',
                    readTerms: 'read terms of service'
                },
                'change-admin-data': {
                    user: 'User {0} edited {1} account',
                    add: 'filled a field "{0}" with value "{1}"',
                    change: 'changed a "{0}" field from "{1}" to "{2}"'
                },
                'change-role': {
                    user: 'User {0} changed role {1}',
                    name: 'name from {0} to {1}',
                    permissions: 'permissions list from [{0}] to [{1}]',
                    categories: 'reports categories list from [{0}] to [{1}]',
                    activity: 'role was',
                    enabled: 'enabled',
                    disabled: 'disabled'
                },
                'edit-client-group': {
                    result: 'Client group "{0}" was changed',
                    change: 'field "{0}" from {1} to {2}',
                    linkClients: '{0}\'s user clients was included',
                    unlinkClients: '{0}\'s user clients was excluded'
                },
                'edit-cashback-system': {
                    result: 'Cashback system "{0}" was changed',
                    change: 'field "{0}" from {1} to {2}'
                },
                'edit-ra-system': {
                    result: '"Reach amount" bonus system "{0}" was changed',
                    change: 'field "{0}" from {1} to {2}'
                },
                'edit-lt-system': {
                    result: '"Limited time" bonus system "{0}" was changed',
                    change: 'field "{0}" from {1} to {2}'
                },
                'funds-purchase': 'Bought promotional funds: {0} by coefficient {1}',
                'funds-charge': {
                    admin: {
                        all: {
                            leader: 'Promotional balance all of leaders (amount - {0}) was refilled by {1} ₴',
                            business: 'Promotional balance all of businesses (amount - {0}) was refilled by {1} ₴',
                            client: 'Promotional balance all of clients (amount - {0}) was refilled by {1} ₴'
                        },
                        some: {
                            leader: 'Leader (id: {0}) promotional balance was refilled by {1} ₴',
                            business: 'Business (id: {0}) promotional balance was refilled by {1} ₴'
                        },
                        amount: {
                            leader: 'Promotional balance of leaders, which have more than {0} businesses (amount - {1}), was refilled by {2} ₴',
                            business: 'Promotional balance of businesses, which have more than {0} clients (amount - {1}), was refilled by {2} ₴'
                        },
                        date: {
                            leader: 'Promotional balance of leaders, who registered {0} {1} (amount - {2}), was refilled by {3} ₴',
                            business: 'Promotional balance of businesses, who registered {0} {1} (amount - {2}), was refilled by {3} ₴'
                        }
                    },
                    leader: {
                        all: {
                            business: 'Refilled promotional balance of all his businesses (amount - {0}) by {1} ₴',
                            client: 'Refilled promotional balance of all his clients (amount - {0}) by {1} ₴'
                        },
                        some: {
                            business: 'Refilled promotional balance of his business (id: {0}) by {1} ₴'
                        },
                        amount: {
                            business: 'Refilled promotional balance of his businesses, which have more than {0} clients (amount - {1}), by {2} ₴'
                        },
                        date: {
                            business: 'Refilled promotional balance of his businesses, who registered {0} {1} (amount - {2}), by {3} ₴'
                        }
                    },
                    business: {
                        all: {
                            client: 'Refilled promotional balance of his clients (amount - {0}) by {1} ₴'
                        }
                    },
                    before: 'before',
                    after: 'after'
                },
                'change-account-status': 'Status of account "{0}" was changed from "{1}" to "{2}"',
                'change-account-price': 'Field "{0}" of account "{1}" was changed from "{2}" to "{3}"',
                amountToPay: 'Amount to pay',
                amountPaid: 'Amount paid',
                enabled: 'enabled',
                disabled: 'disabled',
                locked: 'locked',
                unlocked: 'unlocked'
            },
            settings: {
                name: 'Logging type',
                activation: 'Activation'
            }
        },
        Reset: {
            title: 'Change your password',
            labels: {
                newPassword: 'New password',
                confirmPassword: 'Re-enter password'
            }
        },
        PromotionalAccount: {
            before: 'Before',
            after: 'After',
            promotionalAccountReplenishment: 'Promotion account replenishment',
            purchaseRate: 'The current purchase rate',
            willBeBought: 'Will be bought',
            wannaSpend: 'Want to spend',
            additionalSettings: 'Additional settings',
            numberOfUsers: 'Number of users for accrual',
            numberOfFunds: 'Number of funds for accrual',
            numberOfClients: 'Number of clients',
            numberOfBusinesses: 'Number of businesses',
            promotionalAccountBalance: 'Your promotional account balance is',
            advertisingBalance: 'Advertising balance',
            mainBalance: 'Main balance',
            leader: {
                all: 'All leaders',
                some: 'Certain leader',
                amount: 'Number of businesses more than N',
                date: 'Registration before/after'
            },
            business: {
                all: 'All Businesses',
                some: 'Certain business',
                amount: 'Number of clients more than N',
                date: 'Registration before/after'
            },
            client: {
                all: 'All clients',
                some: 'Business Clients'
            }
        },
        Groups: {
            table: {
                id: 'Group ID',
                establishment: 'Establishment',
                name: 'Name',
                selection: 'Selection',
                type: 'Type',
                values: 'Count of orders',
                includeUnallocated: 'Include unallocated',
                onlyUnallocated: 'Only unallocated',
                fromDate: 'From date',
                toDate: 'To date',
                accountId: 'System account',
                clients: 'Client cnt',
                createdAt: 'Created at',
                used: 'Used',
                phones: 'Phones',
                actions: 'Actions',
                brand: 'Brand',
                scope: 'Scope',
                bonusSystem: 'Bonus type',
                autoAdd: 'Auto add',

                bonusSystems: {
                    sum: 'Spent sum',
                    count: 'Order count',
                    cashbackPercent: 'cashback %'
                }
            },
            relocationOfClients: 'Reallocation of clients',
            someClientsAreAlreadyInGroup: 'Some of the clients are already in another group. Please note that during group creation they will be transferred to it.',
            validation: {
                success: 'Success',
                validationError: 'Validation error',
                alreadyInGroup: 'Already in group',
                notFound: 'Not found'
            },
            allEstablishments: 'All establishments',
            all: 'All',
            editor: {
                create: 'Create group',
                edit: 'Edit group',
                startTyping: 'Start typing for search',
                subGroups: 'Sub groups',
                clientsCount: 'Clients count',
                willBeSentToAllClients: 'Includes all clients',
                autoAddNewClients: 'Auto add new clients',
                removeDialog: {
                    title: 'Remove group?',
                    desc: 'This group will be completely removed from the system.'
                }
            },
            selections: {
                custom: 'Custom',
                condition: 'Condition',
                taxi: 'Taxi',
                delivery: 'Delivery'
            },
            types: {
                equal: 'Equal',
                less: 'Less',
                more: 'More',
                range: 'Range'
            },
            filters: {
                valuesFrom: 'Count of orders from',
                valuesTo: 'Count of orders to'
            },
            bonusSystems: {
                sum: 'By the sum of spent money',
                count: 'By order count',
                cashbackPercent: 'Cashback percent (default)'
            },
            cashbackSystem: 'Cashback system',
            countOfClients: 'Count of clients',
            withGroup: 'In groups',
            withoutGroup: 'Not in groups',
            unallocated: 'Unallocated',
            manualMode: 'Manual mode',
            isDelivery: 'Delivery'
        },
        Cashback: {
            table: {
                id: 'Cashback ID',
                name: 'Name',
                groupId: 'Group',
                fromDate: 'From date',
                toDate: 'To date',
                enabled: 'Enabled',
                wasStartedUp: 'Was started up',
                progress: 'Progress',
                clients: 'Count of clients',
                totalOrderCount: 'Total order count',
                totalCommission: 'Total commission',
                totalCashback: 'Total cashback',
                includeTelephony: 'Include offline orders',
                createdAt: 'Created at',
                deletedAt: 'Deleted at',
                actions: 'Actions',
                groupType: 'Group type',
                bonusSystem: 'Bonus type',
                brand: 'Brand'
            },
            useAsTemplate: 'Using the cashback system as a template',
            filters: {
                countClientsFrom: 'Count of clients from',
                countClientsTo: 'Count of clients to',
                totalOrderFrom: 'Total orders count from',
                totalOrderTo: 'Total orders count to'
            }
        },
        CashbackEditor: {
            mainParams: 'Main parameters',
            sequencesTable: 'Consecutive accrual table',
            table: {
                order: 'Order',
                percent: 'Percent',
                text: 'Push notification text',
                actions: 'Actions',
                amount: 'Return amount',
                count: 'Order count',
                sum: 'Spent sum'
            }
        },
        Moderation: {
            statuses: {
                success: 'Success',
                check: 'Check',
                filling: 'Filling',
                cancelled: 'Cancelled'
            },
            table: {
                type: 'Type',
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Email',
                phoneNumber: 'Phone number',
                cardNumber: 'Card number',
                taxId: 'Tax ID',
                passportNumber: 'Passport number',
                status: 'Status',
                createdAt: 'Created at'
            }
        },
        404: {
            title: 'Oops!',
            text: 'Looks like you\'re in uncharted territory. We don\'t know about this page yet. Luckily, we know the way back.',
            return: 'Back'
        }
    },
    types: {
        admin: 'Admin',
        leader: 'Leader',
        business: 'Business',
        client: 'Client'
    },
    messages: {
        error: {
            invalidToken: 'Invalid device token',
            unknown: 'Unknown error',
            isPhoneExist: 'Phone number already exist',
            isAccountExist: 'Account already in system',
            isCodeValid: 'Confirmation code is not valid',
            emailAlreadyExist: 'Email already exist',
            accountAlreadyExist: 'Account already exist',
            passwordDoesntMatch: 'Passwords does not match',
            accountNotFound: 'Account not found',
            incorrectEmailOrPassword: 'Email or password incorrect',
            tokenInvalid: 'Token is not valid',
            notAllAccountInformation: 'To withdraw funds, fill in the personal information in your account settings',
            invalidSum: 'Amount is incorrect',
            newsNotFound: 'News does not exist',
            emailNotConfirmed: 'Email not verified',
            invalidAmount: 'Amount is incorrect',
            phoneNotFound: 'Phone number is not exist',
            countUsers: 'Users with these options are not found',
            accessDenied: 'Access denied for your role',
            roleNotFound: 'Role not found',
            reportNotFound: 'Report not found',
            reportGenerateError: 'Error while generate SQL-report',
            roleIdIsRequired: 'Can\'t create without role',
            cannotDisableOwnRole: 'You can\'t disable your own role',
            findAccountWithThisRole: 'Unable to remove role while at least one account belongs to it',
            reportFoundWithThisCategory: 'This category includes reports',
            incorrectEmail: 'Email incorrect',
            duplicateName: 'This name is already taken',
            accountLocked: 'Your account was locked. Contact the administration',
            autologout: 'You\'ve been away too long! Please, re-login',
            lessThanMin: 'Less than minimal',
            moreThanLimit: 'More than limit',
            limits: {
                lessThanExistAccounts: 'Less than exist accounts',
                lessThanExistClients: 'Less than exist clients',
                cantBeLimited: 'Account cannot be limited'
            },
            greaterThanLeaderFee: 'You cannot share more than you have',
            telephonyDisabled: 'Offline orders not included',
            accountAmount: {
                lessThanMin: 'Less than minimal',
                moreThanMax: 'More than maximum',
                lessThanPaid: 'Less than already paid',
                moreThanNeedPay: 'More than have to pay'
            }
        },
        success: {
            resend: 'An SMS with a verification code has been sent to your phone',
            login: 'Success login',
            register: 'Account created successfully. Please go to the mail and confirm the registration!',
            registerAdmin: 'Account created successfully',
            successMessage: 'Messages successfully sent.',
            deletedArticle: 'Article was deleted',
            savedArticle: 'Article was deleted',
            createdArticle: 'Created article',
            copy: 'Copied to clipboard',
            accountRegister: 'Account created successfully. Please go to the mail and confirm the registration',
            accountUpdated: 'Account successfully updated',
            passwordChanged: 'Password successfully changed',
            feedCreated: 'Feed successfully posted',
            feedUpdated: 'Feed successfully updated',
            feedDeleted: 'Feed successfully deleted',
            linkShared: 'Link successfully shared',
            refillBalance: 'Balance successfully refilled',
            refillPromoBalance: 'Promotional Balance successfuly refilled',
            confirmBusiness: 'Account successfully confirmed',
            updated: 'Updated',
            success: 'Successful operation',
            role: {
                updated: 'Role successfully updated',
                created: 'New role successfully',
                removed: 'Role successfully removed'
            },
            report: {
                updated: 'Report successfully updated',
                created: 'New report successfully created',
                removed: 'Report successfully removed'
            },
            category: {
                updated: 'Category successfully updated',
                created: 'New category successfully created',
                removed: 'Category successfully removed'
            }
        }
    },
    authorManagement: 'The account is copyrighted until {0}',
    buttons: {
        create: 'Create',
        cancel: 'Cancel',
        delete: 'Delete',
        save: 'Save',
        next: 'Next',
        ok: 'OK',
        change: 'Change',
        resend: 'Not received sms',
        changePhoneNumber: 'Change phone number',
        search: 'Search',
        reset: 'Reset',
        send: 'Send',
        checkPhones: 'Check phones',
        apply: 'Apply',
        update: 'Update',
        download: 'Download',
        upload: 'Upload',
        withdraw: 'Withdraw',
        generate: 'Generate',
        excel: 'Завантажити таблицю',
        refill: 'Refill',
        charge: 'Charge',
        calculate: 'Сalculate',
        buy: 'Buy',
        hide: 'Hide',
        enabled: 'Enabled',
        disabled: 'Disabled',
        complete: 'Complete',
        use: 'Use',
        check: 'Check',
        resetFee: 'Reset fee',
        excludeResetFee: 'Include reset fee'
    },
    notifications: {
        delete: 'Are you sure you want to delete this code?',
        deletePayout: 'Are you sure you want to cancel the request for payment?'
    },
    table: {
        load: 'Data is loading...',
        noData: 'Data is not available'
    },
    phone: {
        countrySelectorLabel: 'Country code',
        phoneNumberLabel: 'Phone number',
        example: 'Example:'
    },
    date: {
        fromDate: 'Start date',
        toDate: 'End date',
        date: 'Date',
        birthday: 'Birthday'
    },
    select: {
        searchBy: 'Search by',
        selectLeader: 'Select leader',
        selectBusiness: 'Select business',
        selectCode: 'Select code',
        noData: 'Data is not available',
        selectType: 'Type'
    },
    links: {
        backToPayments: 'Back to payments'
    },
    markdown: {
        link: 'link',
        text: 'text',
        preview: 'Show preview'
    },
    noData: {
        empty: 'List is empty'
    },
    currencies: {
        hrn: 'hrn'
    },
    true: 'Yes',
    false: 'No',
    noDataText: 'No data',
    others: '{0} others',
    dataIterator: {
        noResultsText: 'No result'
    },
    editDialog: {
        saveText: 'Press Enter to save'
    },
    validateData: {
        cancelled: 'The data has not been moderated. Enter correct data and submit data for moderation.',
        check: 'The data is being verified.',
        filling: 'Fill in all personal data to continue working in the system. If you enter incorrect data, your account may be blocked.'
    }
}
